import { DEVICE_TYPE, LEAVE_ROLE, FAMILY_CALL_FRARED } from '@/utils/constUtils'
import {
  facedoorH5Url,
  visitorH5Url,
  h5Host,
  lockDoorUrl,
  imagicubeUrl
} from '@/env'
import { getCorpId } from '@/utils/comUtils'
const corpId = getCorpId() || ''
/********************************************************************
 * 上下学管理
 ********************************************************************/
export const mainMenus = [
  {
    id: 1,
    name: '学生考勤',
    path: '/attendance/index',
    icon: '&#xe675;',
    module: '1',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 2,
    name: '学生请假',
    path: '/leave/index',
    icon: '&#xe677;',
    module: '2',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 161,
    name: '进出校管理',
    path: '/opendoor/index',
    icon: '&#xe796;',
    module: '161',
    access: [LEAVE_ROLE.admin]
  },
  {
    id: 30,
    name: '班级放学',
    icon: '&#xe6e6;',
    module: '30',
    path: '/afterschool/index',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.elecTeacher,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 8,
    name: '滞留生托管',
    path: '/flexleave/index',
    icon: '&#xe672;',
    module: '8',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 31,
    name: '学生留堂',
    title: 'detention',
    path: '/afterschool/detention/index',
    icon: '&#xe6e7;',
    module: '31',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 95,
    name: '智慧停车',
    path: '/vehiclemanage/index',
    icon: '&#xe6c4;',
    module: '95',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster, LEAVE_ROLE.customRole]
  },
  {
    id: 7,
    name: '数据大屏',
    path: '/screen/index',
    icon: '&#xe678;',
    module: '7',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.customRole, LEAVE_ROLE.headmaster]
  },
  {
    id: 90,
    name: '测温统计',
    linkType: 2, // 外链 mcOpenLink({ url: path] })
    path: `${h5Host}/?corpId=${corpId}&to=health`,
    icon: '&#xe747;',
    module: '90',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster, LEAVE_ROLE.guardian]
  },
  {
    id: 162,
    name: '在校统计',
    path: '/atschool/summary',
    icon: '&#xe79d;',
    module: '162',
    access: [LEAVE_ROLE.admin]
  },
  {
    id: 22,
    name: '给孩子留言',
    path: '/classcard/classrank/message',
    icon: '&#xe6df;',
    module: '22',
    access: [LEAVE_ROLE.guardian]
  }
]

/********************************************************************
 * 校园安全
 ********************************************************************/

export const securityMenus = [
  {
    id: 110,
    name: '行为安全',
    icon: '&#xe790;',
    module: '110',
    path: '/security/overview',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.customRole,
      LEAVE_ROLE.securityPolicer,
      LEAVE_ROLE.securityManager
    ]
  },
  {
    id: 114,
    name: '一键找人',
    title: 'detention',
    path: '/track/addressbook',
    icon: '&#xe791;',
    module: '113',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.customRole, LEAVE_ROLE.headmaster]
  }
]

/********************************************************************
 * 教务教学
 ********************************************************************/

export const educationalMenus = [
  {
    id: 51,
    name: '智能排课',
    path: '/banner6_schedule',
    icon: '&#xe730;',
    module: '51',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 26,
    name: '班级课表',
    multiple: true,
    termNotNull: true,
    icon: '&#xe734;',
    module: '26',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.guardian
    ],
    path: {
      1: '/schedule/student', // 家长
      [LEAVE_ROLE.classTeacher]: '/schedule/timetable'
    }
  },
  {
    id: 52,
    name: '调代课',
    title: 'substitute',
    path: '/substitute/index',
    module: '52',
    termNotNull: true,
    icon: '&#xe735;',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 44,
    name: '选修课',
    icon: '&#xe6ae;',
    module: '44',
    multiple: true,
    termNotNull: true,
    access: [
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.admin
    ],
    path: {
      1: '/elective/student', // 家长
      [LEAVE_ROLE.classTeacher]: '/elective/teacher'
    }
  },
  {
    id: 48,
    name: '学生签到',
    title: 'studentSign',
    path: '/studentSign/index',
    module: '48',
    termNotNull: true,
    icon: '&#xe74e;',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.customRole,
      LEAVE_ROLE.behaviorTeacher
    ]
  },
  {
    id: 151,
    title: 'behavior',
    name: '课堂行为',
    path: `/behavior/index`,
    icon: '&#xe795;',
    module: '151',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.behaviorTeacher
    ]
  }
]

/********************************************************************
 * 总务后勤
 ********************************************************************/

export const serveMenus = [
  {
    id: 4,
    name: '学生宿舍',
    path: '/dorm/index',
    icon: '&#xe679;',
    module: '4',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.dormAdmin,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 29,
    name: '亲情通话',
    icon: '&#xe69a;',
    module: '29',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.customRole,
      LEAVE_ROLE.guardian
    ],
    multiple: true,
    path: {
      [LEAVE_ROLE.classTeacher]: '/classcard/familycall/list',
      1: '/familycall/guardian', // 家长
      3: '/classcard/familycall/list'
    }
  },

  {
    id: 70,
    name: '每日食谱',
    icon: '&#xe6d2;',
    module: '70',
    termNotNull: true,
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.customRole
    ],
    path: '/recipes/adminDaily'
  },
  {
    id: 81,
    title: 'meeting',
    linkType: 2,
    module: '81',
    name: '预约会议室',
    path: `https://focus.dingtalk.com/focusApp/index.html?corpId=${corpId}&from=microapp#/`,
    icon: '&#xe674;',
    access: [LEAVE_ROLE.admin]
  },
  {
    id: 46,
    module: '46',
    title: 'visitor',
    name: '预约访客',
    linkType: 2,
    path: `${visitorH5Url}?corpId=${corpId}`,
    icon: '&#xe673;',
    access: [LEAVE_ROLE.admin]
  },
  {
    id: 24,
    name: '通知公告',
    path: '/classcard/welcome',
    query: { publishType: 2 },
    icon: '&#xe693;',
    module: '24',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster, LEAVE_ROLE.customRole]
  },
  {
    id: 23,
    name: '欢迎词',
    path: '/classcard/welcome',
    icon: '&#xe691;',
    module: '23',
    query: { publishType: 1 },
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.customRole]
  },
  {
    id: 121,
    title: 'cabinet',
    name: '智能传递柜',
    path: `${imagicubeUrl}?corpId=${corpId}&redirectCode=C001`,
    icon: '&#xe733;',
    module: '121',
    access: [LEAVE_ROLE.admin]
  }
]

/********************************************************************
 * 综合评价
 ********************************************************************/
export const evaluationMenus = [
  {
    id: 20,
    name: '德育考评',
    title: 'moral',
    termNotNull: true,
    multiple: true,
    path: {
      1: '/classcard/moralstudent', // 家长
      [LEAVE_ROLE.classTeacher]: '/classcard/moral'
    },
    icon: '&#xe709;',
    module: '20',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.meTeacher,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 21,
    name: '班级评比',
    title: 'classrank',
    termNotNull: true,
    path: '/classcard/classrankall',
    icon: '&#xe708;',
    module: '21',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.ceTeacher,
      LEAVE_ROLE.meTeacher,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.customRole,
      LEAVE_ROLE.classrankApprover
    ]
  },
  {
    id: 43,
    title: 'classEvaluation',
    name: '课堂评价',
    path: '/classevaluation/index',
    icon: '&#xe6a7;',
    module: '43',
    termNotNull: true,
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 41,
    name: '学生荣誉',
    path: '/classcard/honour/list',
    icon: '&#xe69c;',
    module: '41',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster, LEAVE_ROLE.customRole]
  },
  {
    id: 42,
    name: '光盘行动',
    icon: '&#xe6a8;',
    module: '42',
    multiple: true,
    termNotNull: true,
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.student,
      LEAVE_ROLE.customRole
    ],
    path: {
      1: '/classcard/clearplate/personal', // 家长
      7: '/classcard/clearplate/personal', // 学生
      [LEAVE_ROLE.classTeacher]: '/classcard/clearplate'
    }
  }
]

/********************************************************************
 * 放学管理
 ********************************************************************/

export const leaveSchoolMenus = []
/**
 * 预约管理
 */
export const otherMenus = []
/**
 * 设备管理
 */
export const devicesMenus = [
  {
    id: 27,
    module: '27',
    routerType: 2,
    name: '智慧班牌',
    path: `/classcard/mamage`,
    query: { deviceType: [DEVICE_TYPE.T1, DEVICE_TYPE.T21] },
    icon: '&#xe71b;',
    access: [LEAVE_ROLE.admin]
  },
  {
    id: 32,
    module: '32',
    routerType: 2,
    name: '亲情通话机',
    path: `/classcard/mamage`,
    query: { deviceType: FAMILY_CALL_FRARED },
    icon: '&#xe762;',
    access: [LEAVE_ROLE.admin]
  },
  {
    id: 6,
    module: '6',
    title: 'facedoor',
    name: '智能门禁',
    path: `${facedoorH5Url}?corpId=${corpId}&type=shortcut`,
    icon: '&#xe676;',
    access: [LEAVE_ROLE.admin]
  },
  {
    id: 110,
    module: '110',
    routerType: 2,
    name: '无感设备',
    path: `/aiBox/index`,
    icon: '&#xe75f;',
    access: [LEAVE_ROLE.admin]
  },
  {
    id: 140,
    title: 'lockdoor',
    module: '140',
    name: '智能门锁',
    path: `${lockDoorUrl}?corpId=${corpId}#/`,
    icon: '&#xe794;',
    access: [LEAVE_ROLE.admin]
  },
  {
    id: 112,
    name: '防欺凌设备',
    routerType: 2,
    path: '/antibully/device',
    icon: '&#xe78e;',
    module: '112',
    access: [LEAVE_ROLE.admin]
  }
]

/********************************************************************
 * 基础设置
 ********************************************************************/

let _basicMenus = [
  {
    id: 28,
    title: 'schoolCalendar',
    name: '学期时间',
    path: '/schoolCalendar',
    icon: '&#xe775;',
    module: '28',
    access: [LEAVE_ROLE.admin]
  },
  {
    id: 5,
    title: 'info',
    name: '信息录入',
    multiple: true,
    path: {
      [LEAVE_ROLE.classTeacher]: '/entryInformation/index',
      1: '/entryInformation/guardian/index',
      3: '/entryInformation/index'
    },
    icon: '&#xe67b;',
    module: '5',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.guardian, LEAVE_ROLE.classTeacher]
  },
  {
    id: 301,
    title: 'rights',
    name: '权益中心',
    path: '/rights/index',
    icon: '&#xe6dc;',
    module: '301',
    access: [LEAVE_ROLE.admin]
  }
]

if (corpId === 'ding215f16be7cb2343135c2f4657eb6378f') {
  _basicMenus = [
    ..._basicMenus,
    {
      id: 666,
      name: '授权',
      path: '/other/authorize',
      icon: '&#xe677;',
      module: '666'
    }
  ]
}

export const basicMenus = _basicMenus
